module.exports = __webpack_public_path__ + "img/113d7574349e4881b2e9b6d1b57ee1fe-1024.cc220f11.jpg";